<div class="widget" 
  [ngClass]="{
    'widget--open': open, 
    'widget--fixed': !canToggle, 
    'widget--compact': isCompact 
  }">
  <div class="widget__header" (click)="handleClickHeader()" *ngIf="label">
    <div class="widget__label text-12">{{ label }}</div>

    <div class="widget__actions" appEventFence>
      <ng-content select="[widget-actions]"></ng-content>
    </div>

    <div class="widget__toggle rotate--animate" [class.rotate-90]="open" [class.rotate-0]="!open" *ngIf="canToggle">
      <fa-icon icon="angle-right"></fa-icon>
    </div>
  </div>

  <div class="widget__body">
    <ng-content></ng-content>
  </div>
</div>